import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=254b58dc&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=254b58dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b58dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
